import React, { useMemo } from "react";
import Stats from "../Quants.js/Stats";
import OrderStats from "../Quants.js/Orders";
import RevenueStats from "../Quants.js/Revenue";
import useAnalyticsData from "./Hooks/useAnalyticsData";
import AnalyticsPageHeader from "./AnalyticsPageHeader";
import AnalyticsFilterBar from "./AnalyticsFilterBar";
import { FaStore, FaUsers, FaShoppingBag, FaTshirt } from "react-icons/fa";

const ClothingAnalytics = () => {
  const {
    analyticsData,
    date,
    today,
    isFilterApplied,
    handleStartDateChange,
    handleEndDateChange,
    fetchData,
  } = useAnalyticsData();

  const topStats = useMemo(() => {
    return [
      {
        label: "Total Sellers",
        value: analyticsData?.total_sellers || 0,
        icon: <FaStore />,
        color: "#6C63FF",
      },
      {
        label: "Total Buyers",
        value: analyticsData?.total_buyer || 0,
        icon: <FaUsers />,
        color: "#0D6EFD",
      },
      {
        label: "Total Orders",
        value: analyticsData?.total_orders || 0,
        icon: <FaShoppingBag />,
        color: "#198754",
      },
    ];
  }, [analyticsData]);

  return (
    <div className="container-fluid py-4">
      <AnalyticsPageHeader
        theme="cloth"
        icon={<FaTshirt />}
        title="Clothing Analytics"
        subtitle="Track sellers, buyers, orders and revenue across the clothing marketplace"
      />

      <AnalyticsFilterBar
        date={date}
        today={today}
        isFilterApplied={isFilterApplied}
        onStartDateChange={handleStartDateChange}
        onEndDateChange={handleEndDateChange}
        onApply={fetchData}
      />

      {/* Top Cards */}
      <Stats topStats={topStats} />

      {/* Orders */}
      <OrderStats analyticsData={analyticsData} />

      {/* Revenue */}
      <RevenueStats analyticsData={analyticsData} />
    </div>
  );
};

export default ClothingAnalytics;
